// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__29_rb","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2RUqE","obliqueLine":"membershipbadge_obliqueLine__y3XJy"};